import { render } from "./ContactView.vue?vue&type=template&id=84c7f286&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=84c7f286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c7f286"]])

export default __exports__